import apiClient from '../config/api';

const oplService = {
  /**
   * Get all OPL documents for the current tenant
   * @param {number} machineId - Optional machine ID filter
   * @param {number} statusId - Optional status ID filter
   * @returns {Promise} Array of OPL documents
   */
  getAllOplDocuments: async (machineId = null, statusId = null) => {
    const params = {};
    if (machineId) params.machineId = machineId;
    if (statusId) params.statusId = statusId;
    
    const response = await apiClient.get('/opldocument', { params });
    return response.data;
  },

  /**
   * Get OPL document by ID
   * @param {number} id - OPL document ID
   * @returns {Promise} OPL document details
   */
  getOplDocumentById: async (id) => {
    const response = await apiClient.get(`/opldocument/${id}`);
    return response.data;
  },

  /**
   * Create a new OPL document
   * @param {object} oplData - OPL document data
   * @returns {Promise} Created OPL document
   */
  createOplDocument: async (oplData) => {
    const response = await apiClient.post('/opldocument', oplData);
    return response.data;
  },

  /**
   * Update OPL document
   * @param {number} id - OPL document ID
   * @param {object} oplData - Updated OPL document data
   * @returns {Promise} Update result
   */
  updateOplDocument: async (id, oplData) => {
    const response = await apiClient.post(`/opldocument/update/${id}`, oplData);
    return response.data;
  },

  /**
   * Create a new version of an OPL document
   * @param {number} id - Original OPL document ID
   * @param {object} newVersionData - New version data
   * @returns {Promise} Created new version
   */
  createNewVersion: async (id, newVersionData) => {
    const response = await apiClient.post(`/opldocument/${id}/version`, newVersionData);
    return response.data;
  },

  /**
   * Approve an OPL document
   * @param {number} id - OPL document ID
   * @returns {Promise} Approval result
   */
  approveOplDocument: async (id) => {
    const response = await apiClient.post(`/opldocument/${id}/approve`);
    return response.data;
  },

  /**
   * Delete OPL document
   * @param {number} id - OPL document ID
   * @returns {Promise} Deletion result
   */
  deleteOplDocument: async (id) => {
    const response = await apiClient.post(`/opldocument/delete/${id}`);
    return response.data;
  },
};

export default oplService;






































































